var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5556 0C9.27009 0 7.03594 0.677721 5.13564 1.94746C3.23534 3.2172 1.75423 5.02193 0.879619 7.13344C0.0050068 9.24494 -0.223832 11.5684 0.222042 13.8099C0.667916 16.0515 1.76848 18.1105 3.38455 19.7266C5.00062 21.3426 7.05963 22.4432 9.30118 22.8891C11.5427 23.3349 13.8662 23.1061 15.9777 22.2315C18.0892 21.3569 19.8939 19.8758 21.1637 17.9755C22.4334 16.0752 23.1111 13.841 23.1111 11.5556C23.1111 8.49083 21.8937 5.55163 19.7266 3.38454C17.5595 1.21746 14.6203 0 11.5556 0ZM19.1028 7.67722L9.61278 17.16L4.00834 11.5556C3.81679 11.364 3.70918 11.1042 3.70918 10.8333C3.70918 10.5624 3.81679 10.3027 4.00834 10.1111C4.19988 9.91957 4.45967 9.81196 4.73056 9.81196C5.00145 9.81196 5.26124 9.91957 5.45278 10.1111L9.62723 14.2856L17.6728 6.24722C17.7676 6.15238 17.8802 6.07714 18.0041 6.02582C18.1281 5.97449 18.2609 5.94807 18.395 5.94807C18.5291 5.94807 18.6619 5.97449 18.7859 6.02582C18.9098 6.07714 19.0224 6.15238 19.1172 6.24722C19.2121 6.34207 19.2873 6.45466 19.3386 6.57858C19.39 6.7025 19.4164 6.83531 19.4164 6.96944C19.4164 7.10357 19.39 7.23639 19.3386 7.36031C19.2873 7.48423 19.2121 7.59682 19.1172 7.69167L19.1028 7.67722Z",
    fill: "#30BB4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.9f38c4e38ffb3683d5de36f4efa5b972.svg";
export { ForwardRef as ReactComponent };